import Vue from 'vue'
import {
  Button,
  Container,
  Header,
  Aside,
  Main,
  Menu,
  Submenu,
  Row,
  Col,
  MenuItem,
  MenuItemGroup,
  Form,
  FormItem,
  Input,
  Dialog,
  Checkbox,
  Table,
  TableColumn,
  Select,
  Option,
  DatePicker,
  TimePicker,
  Pagination,
  Tag,
  CascaderPanel,
  Icon,
  Card,
  Progress,
  Tabs,
  TabPane,
  MessageBox,
  Message,
  Notification,
  Steps,
  Step,
  Upload,
  RadioGroup,
  Radio,
  Carousel,
  CarouselItem,
  Loading
} from 'element-ui'

Vue.use(Button)
Vue.use(Container)
Vue.use(Header)
Vue.use(Aside)
Vue.use(Main)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(Row)
Vue.use(Col)
Vue.use(MenuItem)
Vue.use(MenuItemGroup)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Dialog)
Vue.use(Checkbox)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Select)
Vue.use(Option)
Vue.use(DatePicker)
Vue.use(TimePicker)
Vue.use(Pagination)
Vue.use(Tag)
Vue.use(CascaderPanel)
Vue.use(Icon)
Vue.use(Card)
Vue.use(Progress)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Steps)
Vue.use(Step)
Vue.use(Upload)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Loading)
Vue.prototype.$message = Message
Vue.prototype.$notify = Notification
Vue.prototype.$msgbox = MessageBox
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$prompt = MessageBox.prompt
